import { IconColumnInsertLeft } from '@tabler/icons-react';
import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';

/**
 * Adds a column before the selected column.
 */
export default function AddColumnBefore({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      label="Vložiť stĺpec vľavo"
      icon={<IconColumnInsertLeft />}
      onClick={() => editor.chain().focus().addColumnBefore().run()}
    />
  );
}
